<template>
    <div
        v-show="modelValue"
        class="fixed top-0 w-full h-full bg-transparent-basic-3 z-[80] flex justify-center items-center"
    >
        <div
            class="w-[27.5rem] rounded-4 shadow-card bg-white flex flex-col"
        >
            <div class="p-4 pb-3 flex justify-between items-center border-b-1 border-border-basic-2">
                <p class="font-heading-sm-semibold">
                    {{ title }}
                </p>
                <a href="javascript:void(0)" class="ml-20" @click="hidePopup">
                    <img src="@/assets/img/app-popup-1.svg" alt="app-popup-1" />
                </a>
            </div>

            <div class="px-4 py-8">
                <div class="font-body-sm-regular text-content-basic-2">
                    {{ content }}
                </div>
                <div v-if="enableCheckbox">
                    <input
                        v-model="checked"
                        type="checkbox"
                        id="checkedItem"
                        class="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded mr-3"
                    />
                    <label for="checkedItem" class="font-inter-body-3 text-content-basic-2">{{
                        checkboxText
                    }}</label>
                </div>
            </div>
            <!-- <div class="h-px bg-border-basic-1 -mx-6 mb-4"></div> -->

            <div class="w-full p-4 border-t-1 border-border-basic-2 flex gap-2 justify-end">
                <DesignButton
                    class="w-[6rem]"
                    btnText="Close"
                    btnSize="MD"
                    btnType="QUATERNARY"
                    :btnDisabled="false"
                    @click-event="hidePopup"
                />
                <DesignButton
                    class="w-[6rem]"
                    btnText="Delete"
                    btnSize="MD"
                    btnType="RED_SOLID"
                    :btnDisabled="requireConfirm && !checked"
                    @click-event="buttonEvent"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, computed } from 'vue';
import DesignButton from '@/components/design-system/design-button.vue';

const props = defineProps({
    modelValue: Boolean,
    title: String,
    content: String,
    checkboxText: String,
    requireConfirm: {
        type: Boolean,
        default: true,
    },
});

const emit = defineEmits(['update:modelValue', 'buttonEvent', 'afterClose']);

let checked = ref(false);
const enableCheckbox = computed(() => props.requireConfirm && !!props.checkboxText);

// modelValue가 true가 될 때마다 checked 초기화
watch(
    () => props.modelValue,
    (newVal) => {
        if (newVal) {
            checked.value = false;
        }
    }
);

function hidePopup() {
    emit('update:modelValue', false);
    emit('afterClose');
}

function buttonEvent() {
    emit('buttonEvent');
}
</script>
